/**
 * Reads marketing / analytics cookies set on .adalo.com for signup attribution.
 * Must run in the browser (uses document.cookie).
 */
export const getAttributionCookies = () => {
  if (typeof document === 'undefined') {
    return {
      ga4ClientId: null,
      firstReferrer: null,
      lpUrl: null,
      utm: null,
      visitorId: null,
    }
  }

  const gaCookie = document.cookie.match(/_ga=GA\d+\.\d+\.(.+?)(?:;|$)/)
  const ga4ClientId = gaCookie ? gaCookie[1] : null

  const firstReferrerRaw = document.cookie.match(/first_referrer=([^;]+)/)?.[1]
  const lpUrlRaw = document.cookie.match(/lp_url=([^;]+)/)?.[1]
  const utmRaw = document.cookie.match(/__gtm_campaign_url=([^;]+)/)?.[1]
  const visitorIdRaw = document.cookie.match(/_visitor_id=([^;]+)/)?.[1]

  const decode = raw => {
    if (raw == null || raw === '') {
      return null
    }
    try {
      const decoded = decodeURIComponent(raw)

      return decoded === '' ? null : decoded
    } catch {
      return raw
    }
  }

  return {
    ga4ClientId,
    firstReferrer: decode(firstReferrerRaw),
    lpUrl: decode(lpUrlRaw),
    utm: decode(utmRaw),
    visitorId: visitorIdRaw || null,
  }
}
